import {
  GET_NG_SENDINGS_REQUEST,
  GET_NG_SENDINGS_SUCCESS,
  GET_NG_SENDINGS_FAILURE,
  GET_NG_SENDINGS_BY_ID_REQUEST,
  GET_NG_SENDINGS_BY_ID_SUCCESS,
  GET_NG_SENDINGS_BY_ID_FAILURE,
  POST_NG_SENDINGS_REQUEST,
  POST_NG_SENDINGS_SUCCESS,
  POST_NG_SENDINGS_FAILURE,
  PUT_NG_SENDINGS_REQUEST,
  PUT_NG_SENDINGS_SUCCESS,
  PUT_NG_SENDINGS_FAILURE,
  POST_NG_SENDINGS_EXCEL_REQUEST,
  POST_NG_SENDINGS_EXCEL_SUCCESS,
  POST_NG_SENDINGS_EXCEL_FAILURE,
  DELETE_NG_SENDINGS_REQUEST,
  DELETE_NG_SENDINGS_SUCCESS,
  DELETE_NG_SENDINGS_FAILURE,
  DELETE_NG_SENDINGS_BY_ID_REQUEST,
  DELETE_NG_SENDINGS_BY_ID_SUCCESS,
  DELETE_NG_SENDINGS_BY_ID_FAILURE,
} from '../../constants/ActionTypes'
import { NgSendingsApi } from '../api/NgSendingsApi';

/*** GET /ng-sendings ***/
const getNgSendingsRequest = (overwrite) => ({
  type: GET_NG_SENDINGS_REQUEST,
  payload: {
    overwrite: overwrite,
  }
});

const getNgSendingsSuccess = (list, pageInfo, overwrite) => ({
  type: GET_NG_SENDINGS_SUCCESS,
  payload: {
    list: list,
    pageInfo: pageInfo,
    overwrite: overwrite,
  }
});

const getNgSendingsFailure = (error) => ({
  type: GET_NG_SENDINGS_FAILURE,
  payload: {
    error: error
  }
});

export function getNgSendings(data, overwrite = false) {
  return async (dispatch) => {
    dispatch(getNgSendingsRequest(overwrite));

    NgSendingsApi.getNgSendings(data, dispatch)
      .then((response) => {
        dispatch(getNgSendingsSuccess(
          response.data.data,
          response.data.meta,
          overwrite,
        ));
      })
      .catch((error) => {
        dispatch(getNgSendingsFailure(error.response.data));
      });
  };
}

/*** GET /ng-sendings/by_id ***/
const getNgSendingsByIdRequest = () => ({
  type: GET_NG_SENDINGS_BY_ID_REQUEST,
});

const getNgSendingsByIdSuccess = (item) => ({
  type: GET_NG_SENDINGS_BY_ID_SUCCESS,
  payload: {
    item: item,
  }
});

const getNgSendingsByIdFailure = (error) => ({
  type: GET_NG_SENDINGS_BY_ID_FAILURE,
  payload: {
    error: error
  }
});

export function getNgSendingsById(id) {
  return async (dispatch) => {
    dispatch(getNgSendingsByIdRequest());

    NgSendingsApi.getNgSendingsById(id, dispatch)
      .then((response) => {
        dispatch(getNgSendingsByIdSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(getNgSendingsByIdFailure(error.response.data));
      });
  };
}

/*** POST /ng-sendings ***/
const postNgSendingsRequest = () => ({
  type: POST_NG_SENDINGS_REQUEST,
});

const postNgSendingsSuccess = (data) => ({
  type: POST_NG_SENDINGS_SUCCESS,
  payload: {
    ng_sendings: data.ng_sendings,
    errors: data.errors,
  }
});

const postNgSendingsFailure = (error) => ({
  type: POST_NG_SENDINGS_FAILURE,
  payload: {
    error: error
  }
});

export function postNgSendings(data) {
  return async (dispatch) => {
    dispatch(postNgSendingsRequest());

    NgSendingsApi.postNgSendings(data, dispatch)
      .then((response) => {
        dispatch(postNgSendingsSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(postNgSendingsFailure(error.response.data));
      });
  };
}

/*** POST /ng-sendings ***/
const postNgSendingsExcelRequest = () => ({
  type: POST_NG_SENDINGS_EXCEL_REQUEST,
});

const postNgSendingsExcelSuccess = (data) => ({
  type: POST_NG_SENDINGS_EXCEL_SUCCESS,
  payload: {
    ng_sendings: data.ng_sendings,
    errors: data.errors,
  }
});

const postNgSendingsExcelFailure = (error) => ({
  type: POST_NG_SENDINGS_EXCEL_FAILURE,
  payload: {
    error: error
  }
});

export function postNgSendingsExcel(data) {
  return async (dispatch) => {
    dispatch(postNgSendingsExcelRequest());

    NgSendingsApi.postNgSendings(data, dispatch)
      .then((response) => {
        dispatch(postNgSendingsExcelSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(postNgSendingsExcelFailure(error.response.data));
      });
  };
}

/*** PUT /ng-sendings ***/
const putNgSendingsRequest = () => ({
  type: PUT_NG_SENDINGS_REQUEST,
});

const putNgSendingsSuccess = (item) => ({
  type: PUT_NG_SENDINGS_SUCCESS,
  payload: {
    item: item
  }
});

const putNgSendingsFailure = (error) => ({
  type: PUT_NG_SENDINGS_FAILURE,
  payload: {
    error: error
  }
});

export function putNgSendings(data) {
  return async (dispatch) => {
    dispatch(putNgSendingsRequest());

    NgSendingsApi.putNgSendings(data, dispatch)
      .then((response) => {
        dispatch(putNgSendingsSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(putNgSendingsFailure(error.response.data));
      });
  };
}

/*** DELETE /ng-sendings/destroyMulti ***/
const deleteNgSendingsRequest = () => ({
  type: DELETE_NG_SENDINGS_REQUEST,
});

const deleteNgSendingsSuccess = (message) => ({
  type: DELETE_NG_SENDINGS_SUCCESS,
  payload: {
    message: message,
  }
});

const deleteNgSendingsFailure = (error) => ({
  type: DELETE_NG_SENDINGS_FAILURE,
  payload: {
    error: error
  }
});

export function deleteNgSendings(data) {
  return async (dispatch) => {
    dispatch(deleteNgSendingsRequest());

    NgSendingsApi.deleteNgSendings(data, dispatch)
      .then((response) => {
        dispatch(deleteNgSendingsSuccess(response.data.message));
      })
      .catch((error) => {
        dispatch(deleteNgSendingsFailure(error.response));
      });
  };
}


/*** DELETE /ng-sendings_by_id ***/
const deleteNgSendingsByIdRequest = () => ({
  type: DELETE_NG_SENDINGS_BY_ID_REQUEST,
});

const deleteNgSendingsByIdSuccess = () => ({
  type: DELETE_NG_SENDINGS_BY_ID_SUCCESS,
});

const deleteNgSendingsByIdFailure = (error) => ({
  type: DELETE_NG_SENDINGS_BY_ID_FAILURE,
  payload: {
    error: error
  }
});

export function deleteNgSendingsById(data) {
  return async (dispatch) => {
    dispatch(deleteNgSendingsByIdRequest());

    NgSendingsApi.deleteNgSendingsById(data, dispatch)
      .then(() => {
        dispatch(deleteNgSendingsByIdSuccess());
      })
      .catch((error) => {
        dispatch(deleteNgSendingsByIdFailure(error.response));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/NgSendings.js